import React from "react";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { menuOptions } from "../../tabs/pageOptions";

interface MenuOption {
  label: string;
  value: number;
}

interface PageOptionsProps {
  pageOption: string;
  handleChangePageOption: (event: SelectChangeEvent<number>, child: React.ReactNode) => void;
}

const PageOptions: React.FC<PageOptionsProps> = ({ pageOption, handleChangePageOption }) => {
  return (
    <FormControl sx={{ width: "80px"  }}>
      <Select
        sx={{
          height: "38px",
          border: "none",
          fontFamily: '"Plus Jakarta Sans", sans-serif',
        }}
        value={parseInt(pageOption)}
        onChange={handleChangePageOption}
        displayEmpty
        MenuProps={{
          disableScrollLock: true, 
        }}
      >
        {menuOptions.map((menu: MenuOption, index: number) => {
          return (
            <MenuItem
              sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}
              key={index}
              value={menu.value}
            >
              {menu.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default PageOptions;
